// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"c13525e2","845":"96d4e0ae"}[chunkId] + ".chunk.js";
};